import React from 'react';

import './index.css';

interface Props {
    error: string;
}

const ServerErrors: React.FC<Props> = ({ error }) => {
    return <div className="server-errors-wrapper">{error}</div>;
};

export default ServerErrors;
